import React from 'react';
import cx from 'classnames';

const Logo = ({ black }) => (
    <a href="/" className="logoWrap">
        <div className={cx('logo', { black })} />
    </a>
);

export default Logo;
